import {
  createContext,
} from 'react';
import { UserManager, UserManagerSettings, User } from 'oidc-client-ts';

export type CognitoAuthConfig = UserManagerSettings & {
  signoutRedirectArgs: {
    extraQueryParams: {
      client_id: string;
      logout_uri: string;
    };
  };
};

export type CognitoUser = User | null;

export const CUSTOM_LOGIN_URL = process.env.NEXT_PUBLIC_COGNITO_LOGIN_URL;

const cognitoAuthConfig = {
  authority: process.env.NEXT_PUBLIC_COGNITO_AUTHORITY,
  client_id: process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID,
  redirect_uri: process.env.NEXT_PUBLIC_COGNITO_REDIRECT_URI,
  response_type: process.env.NEXT_PUBLIC_COGNITO_RESPONSE_TYPE,
  scope: process.env.NEXT_PUBLIC_COGNITO_SCOPE,
  post_logout_redirect_uri:
    process.env.NEXT_PUBLIC_COGNITO_POST_LOGOUT_REDIRECT_URI,
  silent_redirect_uri: process.env.NEXT_PUBLIC_COGNITO_SILENT_REDIRECT_URI,
  automaticSilentRenew: true,
  monitorSession: true,
  signoutRedirectArgs: {
    extraQueryParams: {
      client_id: process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID,
      logout_uri: process.env.NEXT_PUBLIC_COGNITO_POST_LOGOUT_REDIRECT_URI,
    },
  },
  loadUserInfo: true,
} as CognitoAuthConfig;

export const userManager = new UserManager(cognitoAuthConfig);

const getCognitoLoginEnv = () => {
  const nodeEnv = process.env.NODE_ENV as string;

  if (nodeEnv === 'production') return 'live';

  if (nodeEnv === 'staging') return 'staging';

  return 'dev';
};

export const getCustomLoginURL = () => `${CUSTOM_LOGIN_URL}?client_id=${cognitoAuthConfig.client_id}` +
  `&redirect_uri=${encodeURIComponent(cognitoAuthConfig.redirect_uri || '')}` +
  `&response_type=${encodeURIComponent(cognitoAuthConfig.response_type || '')}` +
  '&response_mode=query' +
  `&env=${getCognitoLoginEnv()}`;

export const cognitoSignOut = async () => {
  await userManager.signoutRedirect(cognitoAuthConfig.signoutRedirectArgs);
};

export type CognitoAuthContextType = {
  user: CognitoUser;
  signIn: () => Promise<void>;
  signOut: () => Promise<void>;
  clearUser: () => void;
  getUser: () => Promise<void>;
  handleSignInCallback: (cognitoUser?: CognitoUser) => Promise<void> }

export const CognitoAuthContext = createContext<CognitoAuthContextType>({
  user: null,
  signIn: async () => {},
  signOut: async () => {},
  clearUser: () => {},
  getUser: async () => {},
  handleSignInCallback: async () => {},
});
